import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { TomosGrid } from './components/TomosGrid';
import { BonosSection } from './components/BonosSection';
import { PricingCards } from './components/PricingCards';
import { BlindajeComparison } from './components/BlindajeComparison';
import { TestimonialsBlock } from './components/TestimonialsBlock';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostoOportunidad } from './components/CostoOportunidad';
import { StackValue } from './components/StackValue';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { SaleNotifications } from './components/SaleNotifications';
const META_PIXEL_ID = '1715709876227103';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    // Avoid double-initializing the pixel
    if (w.fbq) return;
    // Set up the fbq stub queue (official Meta Pixel bootstrap)
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    w.fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Inject the fbevents script safely into <head>. The official snippet
    // inserts before the first <script> tag, but in some environments no
    // such tag exists yet — appending to <head> avoids the parentNode crash.
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const parent = document.head || document.body;
    if (parent) parent.appendChild(t);
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-dark flex flex-col relative w-full overflow-x-hidden" data-id="element-0">
      {/* noscript fallback for Meta Pixel */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>

      <TopBar data-id="element-3" />

      <main className="flex-1" data-id="element-4">
        <Hero data-id="element-5" />
        <SocialProof data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <TomosGrid data-id="element-8" />
        <BonosSection data-id="element-9" />

        {/* First Pricing Section */}
        <PricingCards data-id="element-10" />

        <BlindajeComparison data-id="element-11" />
        <TestimonialsBlock data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FAQ data-id="element-14" />
        <CostoOportunidad data-id="element-15" />

        {/* Final CTA Section - Reusing PricingCards */}
        <div className="pt-12 md:pt-20 bg-brand-light" data-id="element-16">
          <div className="text-center mb-8 px-4" data-id="element-17">
            <h2 className="text-3xl font-black text-white uppercase" data-id="element-18">
              No dejes pasar esta oportunidad
            </h2>
          </div>
          <PricingCards data-id="element-19" />
        </div>

        <StackValue data-id="element-20" />
      </main>

      <Footer data-id="element-21" />
      <StickyCTA data-id="element-22" />
      <SaleNotifications data-id="element-23" />
    </div>;
}